import {
  ADMIN_TASKFORCE,
  CLINIC,
  CT,
  PHYSICIAN_ROLE,
  SPECIALIST_ROLE,
  SPECIALIST_TASKFORCE_ROLE,
  SUPPORT_TASKFORCE_ROLE,
} from '@/constants/role'

export default {
  token: (state) => state.token,
  userId: (state) => state.session?.user?.id,
  sessionId: (state) => state.session?.session?.id,
  clinicId: (state) => state.user?.clinicId,
  // pharmaceuticalId: (state) => state.session?.pharmaceuticalId,
  // pharmaceuticals: (state) => state.user?.pharmaceuticals,
  personId: (state) => state.session?.user?.id,
  aditionalRoutes: (state) => state.session?.user?.aditionalRoutes ?? [],
  userName: (state) => state.session?.user?.name || 'Não identificado',
  isLogged: (state) => !!state.session?.session?.id,
  isAcceptedTerms: (state) => state.user && state.user.acceptedTerms,
  isAdmin: (state, getters) => getters.isLogged && state.session.user.role === 'Admin',
  isPhysician: (_, getters) => getters.userRoles.includes(PHYSICIAN_ROLE),
  isClinic: (_, getters) => getters.userRoles.includes(CLINIC),
  isTaskforceAdmin: (_, getters) => getters.userRoles.includes(ADMIN_TASKFORCE),
  isSpecialist: (_, getters) => getters.userRoles.includes(SPECIALIST_ROLE),
  isTaskforceSpecialist: (_, getters) => getters.userRoles.includes(SPECIALIST_TASKFORCE_ROLE),
  isSupport: (_, getters) => getters.userRoles.includes(SUPPORT_TASKFORCE_ROLE),
  isDoctor: (_, getters) => getters.isPhysician || getters.isSpecialist,
  isCT: (_, getters) => getters.userRoles.includes(CT),
  userRole: (state) => state.user?.role,
  hasRole: (_, getters) => () => !!getters.userRole,
  hasAnyRole:
    (_, getters) =>
    (roles = []) =>
      roles.some((role) => getters.hasRole(role)),
  // pharmaceuticalDomainConfig: (state) => state.pharmaceuticalDomainConfig,
  // defaultHomePage: (state) => state.defaultHomePage,
  // currentHomePage: (state) => state.currentHomePage ?? state.defaultHomePage,
  hasUserBeenDefined: (_, getters) => (getters.personId || getters.clinicId) && !(getters.personId && getters.clinicId),
}
